import React from "react";
import { Chip } from "@mui/material";
import { LOT_STRATEGIES, WAREHOUSE_STRATEGIES } from "../constants";

const ALL_OPTIONS = [...LOT_STRATEGIES, ...WAREHOUSE_STRATEGIES];

export default function StrategyBadge({ value }) {
  const opt = ALL_OPTIONS.find((o) => o.value === value);
  if (!opt) return null;
  return (
    <Chip
      label={opt.label}
      size="small"
      sx={{
        background: opt.gradient,
        color: "#fff",
        fontFamily: "Poppins, sans-serif",
        fontSize: 10,
        fontWeight: 600,
        height: 20,
      }}
    />
  );
}
